
import { createApi } from "@reduxjs/toolkit/query/react";
import { baseAuthQuery } from "../base/baseApi";
import { ApiResponse } from "../base/apiResponse";
import { SchoolResponse } from "../../models/dtos";

export const schoolsApi = createApi({
  reducerPath: 'schoolsApi',
  baseQuery: baseAuthQuery('Schools'),
  tagTypes: ['School'],
  endpoints: (builder) => ({
    getSchools: builder.query<ApiResponse<SchoolResponse[]>, void>({
      query: () => "",
      providesTags: ['School'],
    }),
    getSchoolById: builder.query<ApiResponse<SchoolResponse>, number>({
      query: (id) => ({ url: `/${id}` }),
      providesTags: ['School'],
    }),
    updateSchool: builder.mutation<ApiResponse<SchoolResponse>, Partial<SchoolResponse>>({
      query: (body) => ({ url: "CreateOrUpdate", method: "POST", body }),
      invalidatesTags: ['School'],
    }),
    deleteSchool: builder.mutation<ApiResponse<boolean>, number>({
      query: (id) => ({ url: `Delete/${id}`, method: "GET" }),
      invalidatesTags: ['School'],
    }),
  }),
});
